Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="' +
((__t = (ctx.className)) == null ? '' : __t) +
'">\n  <div class="formio-wizard-position">\n    ' +
((__t = ( ctx.wizardHeader )) == null ? '' : __t) +
'\n    <div class="wizard-page" ref="' +
((__t = (wizardKey)) == null ? '' : __t) +
'">\n      ' +
((__t = (ctx.components)) == null ? '' : __t) +
'\n    </div>\n    ' +
((__t = ( ctx.wizardNav )) == null ? '' : __t) +
'\n  </div>\n</div>';
return __p
}